(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["frequently-bought-together"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('frequently-bought-together')) {
    class FrequentlyBoughtTogether extends HTMLElement {
      connectedCallback() {
        if (!this._bound) {
          this._bound = true;
          this.track = this.querySelector('[data-fbt-track]');
          this.prevBtn = this.querySelector('[data-fbt-prev]');
          this.nextBtn = this.querySelector('[data-fbt-next]');
          this.statusEl = this.querySelector('[data-fbt-status]');

          this.items = Array.from(this.querySelectorAll('[data-fbt-item]')).map((el) => {
            let variants = [];
            try {
              variants = JSON.parse(el.querySelector('[data-fbt-variants]').textContent);
            } catch (e) {}
            return { el, variants, variant: null };
          });

          this.addEventListener('change', (e) => this.handleChange(e));
          this.addEventListener('click', (e) => this.handleClick(e));
          if (this.track) {
            this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
          }
        }

        if (this.track && 'ResizeObserver' in window) {
          this._ro = new ResizeObserver(() => this.updateArrows());
          this._ro.observe(this.track);
        }

        this.items.forEach((item) => this.updateItem(item));
        this.updateTotal();
        this.updateArrows();
      }

      disconnectedCallback() {
        if (this._ro) this._ro.disconnect();
      }

      /* ---------- helpers ---------- */
      itemFor(node) {
        return this.items.find((item) => item.el.contains(node));
      }

      variantFor(item) {
        const input = item.el.querySelector('[data-fbt-variant]');
        if (input) {
          return item.variants.find((v) => String(v.id) === String(input.value)) || item.variants[0];
        }
        return item.variants.find((v) => v.available) || item.variants[0];
      }

      qtyFor(item) {
        const input = item.el.querySelector('[data-fbt-qty]');
        const n = input ? parseInt(input.value, 10) : 1;
        return n > 0 ? n : 1;
      }

      isChecked(item) {
        const cb = item.el.querySelector('[data-fbt-checkbox]');
        return cb ? cb.checked : true;
      }

      selected() {
        return this.items.filter((item) => item.variant && item.variant.available && this.isChecked(item));
      }

      formatMoney(cents) {
        const format = (this.dataset.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, '');
        const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
        const type = match ? match[1] : 'amount';

        const fmt = (precision, thousands = ',', decimal = '.') => {
          const parts = (Number(cents) / 100).toFixed(precision).split('.');
          parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          return parts[1] ? parts[0] + decimal + parts[1] : parts[0];
        };

        const values = {
          amount: fmt(2),
          amount_no_decimals: fmt(0),
          amount_with_comma_separator: fmt(2, '.', ','),
          amount_no_decimals_with_comma_separator: fmt(0, '.', ','),
          amount_with_apostrophe_separator: fmt(2, "'", '.'),
          amount_with_space_separator: fmt(2, ' ', ','),
          amount_no_decimals_with_space_separator: fmt(0, ' ', ','),
        };

        return format.replace(/\{\{\s*\w+\s*\}\}/, values[type] || values.amount);
      }

      setStatus(message, isError = false) {
        if (!this.statusEl) return;
        this.statusEl.textContent = message || '';
        this.statusEl.toggleAttribute('data-error', Boolean(isError));
      }

      /* ---------- events ---------- */
      handleChange(e) {
        const item = this.itemFor(e.target);
        if (!item) return;
        if (e.target.matches('[data-fbt-qty]')) e.target.value = this.qtyFor(item);
        this.updateItem(item);
        this.updateTotal();
      }

      handleClick(e) {
        const btn = e.target.closest('button');
        if (!btn || !this.contains(btn)) return;

        if (btn.hasAttribute('data-fbt-prev')) return this.scrollByCard(-1);
        if (btn.hasAttribute('data-fbt-next')) return this.scrollByCard(1);
        if (btn.hasAttribute('data-fbt-add')) return this.addToCart(false);
        if (btn.hasAttribute('data-fbt-buy')) return this.addToCart(true);

        if (btn.hasAttribute('data-fbt-minus') || btn.hasAttribute('data-fbt-plus')) {
          const item = this.itemFor(btn);
          const input = item && item.el.querySelector('[data-fbt-qty]');
          if (!input) return;
          const step = btn.hasAttribute('data-fbt-plus') ? 1 : -1;
          input.value = Math.max(1, this.qtyFor(item) + step);
          this.updateTotal();
        }
      }

      scrollByCard(direction) {
        if (!this.track) return;
        const card = this.track.querySelector('[data-fbt-item]');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth;
        const rtl = getComputedStyle(this).direction === 'rtl';
        this.track.scrollBy({ left: direction * distance * (rtl ? -1 : 1), behavior: 'smooth' });
      }

      updateArrows() {
        if (!this.track) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const pos = Math.abs(this.track.scrollLeft);
        this.toggleAttribute('data-overflow', max > 2);
        if (this.prevBtn) this.prevBtn.disabled = pos <= 2;
        if (this.nextBtn) this.nextBtn.disabled = pos >= max - 2;
      }

      /* ---------- rendering ---------- */
      updateItem(item) {
        const v = this.variantFor(item);
        if (!v) return;
        item.variant = v;
        const el = item.el;

        const priceEl = el.querySelector('[data-fbt-price]');
        if (priceEl) priceEl.textContent = this.formatMoney(v.price);

        const onSale = v.compare > v.price;
        const compareRow = el.querySelector('[data-fbt-compare-row]');
        if (compareRow) {
          compareRow.hidden = !onSale;
          if (onSale) {
            const compareEl = el.querySelector('[data-fbt-compare]');
            if (compareEl) compareEl.textContent = this.formatMoney(v.compare);
            const badge = el.querySelector('[data-fbt-badge]');
            if (badge) badge.textContent = '-' + Math.round(((v.compare - v.price) * 100) / v.compare) + '%';
          }
        }

        if (v.image) {
          const img = el.querySelector('[data-fbt-image]');
          if (img && img.getAttribute('src') !== v.image) {
            img.removeAttribute('srcset');
            img.src = v.image;
          }
        }

        const cb = el.querySelector('[data-fbt-checkbox]');
        if (cb) cb.disabled = !v.available;
        el.toggleAttribute('data-unchecked', !v.available || !this.isChecked(item));
      }

      updateTotal() {
        const selected = this.selected();
        let total = 0;
        let compare = 0;

        selected.forEach((item) => {
          const qty = this.qtyFor(item);
          total += item.variant.price * qty;
          compare += Math.max(item.variant.compare || 0, item.variant.price) * qty;
        });

        const totalEl = this.querySelector('[data-fbt-total]');
        const compareEl = this.querySelector('[data-fbt-total-compare]');
        const saveEl = this.querySelector('[data-fbt-save]');

        if (totalEl) totalEl.textContent = this.formatMoney(total);
        if (compareEl) {
          compareEl.hidden = compare <= total;
          compareEl.textContent = this.formatMoney(compare);
        }
        if (saveEl) {
          saveEl.hidden = compare <= total;
          saveEl.textContent = 'You save ' + this.formatMoney(compare - total);
        }

        this.querySelectorAll('[data-fbt-add], [data-fbt-buy]').forEach((b) => {
          if (!b.hasAttribute('aria-busy')) b.disabled = selected.length === 0;
        });
      }

      /* ---------- cart ---------- */
      async addToCart(buyNow) {
        const selected = this.selected();
        if (!selected.length) return;

        const buttons = Array.from(this.querySelectorAll('[data-fbt-add], [data-fbt-buy]'));
        const active = this.querySelector(buyNow ? '[data-fbt-buy]' : '[data-fbt-add]');
        buttons.forEach((b) => (b.disabled = true));
        if (active) active.setAttribute('aria-busy', 'true');
        this.setStatus('');

        const sectionIds = Array.from(
          new Set(
            Array.from(document.querySelectorAll('cart-items-component[data-section-id]')).map(
              (el) => el.dataset.sectionId
            )
          )
        );

        const body = {
          items: selected.map((item) => ({ id: item.variant.id, quantity: this.qtyFor(item) })),
        };
        if (!buyNow && sectionIds.length) {
          body.sections = sectionIds.join(',');
          body.sections_url = window.location.pathname;
        }

        try {
          const res = await fetch(this.dataset.cartAddUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(body),
          });
          const data = await res.json();

          if (!res.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add these items to the cart.');
          }

          if (buyNow) {
            window.location.href = this.dataset.checkoutUrl || '/checkout';
            return;
          }

          if (this.dataset.afterAdd === 'cart') {
            window.location.href = this.dataset.cartUrl || '/cart';
            return;
          }

          await this.notifyTheme(data);
          this.setStatus(this.dataset.addedText || 'Added to cart');
        } catch (err) {
          this.setStatus(err.message, true);
        } finally {
          if (active) active.removeAttribute('aria-busy');
          buttons.forEach((b) => (b.disabled = false));
          this.updateTotal();
        }
      }

      async notifyTheme(data) {
        let itemCount;
        try {
          const cartRes = await fetch((this.dataset.cartUrl || '/cart') + '.js');
          const cart = await cartRes.json();
          itemCount = cart.item_count;
        } catch (e) {}

        let dispatched = false;
        try {
          const events = await import('@theme/events');
          if (events && events.CartAddEvent) {
            document.dispatchEvent(
              new events.CartAddEvent({}, this.id || 'frequently-bought-together', {
                source: 'frequently-bought-together',
                itemCount: itemCount,
                sections: data.sections,
              })
            );
            dispatched = true;
          }
        } catch (e) {}

        if (!dispatched) {
          window.location.href = this.dataset.cartUrl || '/cart';
          return;
        }

        try {
          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof drawer.open === 'function') drawer.open();
        } catch (e) {}
      }
    }

    customElements.define('frequently-bought-together', FrequentlyBoughtTogether);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["stock-indicator"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stock-indicator')) {
    customElements.define(
      'stock-indicator',
      class StockIndicator extends HTMLElement {
        connectedCallback() {
          try {
            this.stock = JSON.parse(this.querySelector('[data-stock-map]').textContent);
          } catch (e) {
            this.stock = {};
          }

          // Horizon-family themes fire this when the variant changes
          this.onVariantUpdate = (event) => {
            const id = event.detail && event.detail.resource && event.detail.resource.id;
            if (id) this.render(id);
          };

          // Fallback: read the ?variant= param after any option change
          this.onChange = () => {
            setTimeout(() => {
              const id = new URL(window.location.href).searchParams.get('variant');
              if (id) this.render(id);
            }, 350);
          };

          document.addEventListener('variant:update', this.onVariantUpdate);
          document.addEventListener('change', this.onChange);

          if (this.dataset.cutoff) {
            this.updateDispatch();
            this.timer = setInterval(() => this.updateDispatch(), 30000);
          }
        }

        disconnectedCallback() {
          document.removeEventListener('variant:update', this.onVariantUpdate);
          document.removeEventListener('change', this.onChange);
          clearInterval(this.timer);
        }

        render(id) {
          const v = this.stock[String(id)];
          if (!v) return;

          const threshold = Number(this.dataset.threshold);
          let state = 'in';
          if (!v.available) state = 'out';
          else if (v.tracked && v.qty <= threshold) state = 'low';

          const text = {
            low: (this.dataset.lowText || '').replace('[count]', v.qty),
            in: this.dataset.inText,
            out: this.dataset.outText,
          }[state];

          const hide = !text || (state === 'in' && this.dataset.showIn !== 'true');

          this.dataset.state = state;
          this.querySelector('[data-stock-text]').textContent = text || '';
          this.querySelector('[data-stock-line]').hidden = hide;

          if (this.dataset.cutoff) this.updateDispatch();
        }

        updateDispatch() {
          const el = this.querySelector('[data-dispatch]');
          if (!el) return;

          // Work out "now" in the store's own time zone
          const off = this.dataset.offset || '+0000';
          const sign = off[0] === '-' ? -1 : 1;
          const offMin = sign * (parseInt(off.slice(1, 3), 10) * 60 + parseInt(off.slice(3, 5), 10));
          const shopNow = new Date(Date.now() + offMin * 60000);

          const day = shopNow.getUTCDay();
          const minsNow = shopNow.getUTCHours() * 60 + shopNow.getUTCMinutes();
          const left = Number(this.dataset.cutoff) * 60 - minsNow;
          const weekend = this.dataset.weekdays === 'true' && (day === 0 || day === 6);

          if (weekend || left <= 0 || this.dataset.state === 'out') {
            el.hidden = true;
            return;
          }

          const h = Math.floor(left / 60);
          const m = left % 60;
          const time = h > 0 ? `${h}h ${m}m` : `${m}m`;
          el.querySelector('[data-dispatch-label]').textContent = (this.dataset.dispatchText || '').replace('[time]', time);
          el.hidden = false;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
